import ShareableLinkNotifications from './ShareableLinkNotifications.component';

export default ShareableLinkNotifications;